const CLIENT_CHANGE_STATUSES = {
  pending: { name: "pending", id: "pending" },
  confirmed: { name: "confirmed", id: "confirmed" },
  rejected: { name: "rejected", id: "rejected" },
};

export default CLIENT_CHANGE_STATUSES;
